import { configureStore } from "@reduxjs/toolkit";
import HeaderSlice from "../components/Header/HeaderSlice";
import redirectSlice from "../components/Dashboard/redirectSlice";
import rootReducer from "./rootReducer";

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});
